    <div mat-dialog-title style="margin:0px;">
        <span *ngIf = "!isFolderEdit"> Add Report Folder</span>
        <span *ngIf = "isFolderEdit"> Edit Report Folder</span>
    </div>
    
    <mat-dialog-content>
        <div>
            <table>
                <tr>
                    <td>
                        <tyl-form-field label="Folder Name" style="width:400px;" translate hint="{{100 - (folderName ? folderName.length : 0)}} characters left">
                            <textarea matInput [(ngModel)]="folderName" id="folderName_ID"
                                name="folderName_Name" maxLength="100" required style="width:400px;"
                            >
                            </textarea>
                        </tyl-form-field>
                    </td>
                </tr>
                <tr>
                    <td>
                        <tyl-form-field label="Description" style="width:400px;" translate hint="{{400 - (folderDescription ? folderDescription.length : 0)}} characters left">
                            <textarea matInput [(ngModel)]="folderDescription" id="folderDescription_ID"
                                name="folderDescription_Name" maxLength="400" style="width:400px;" rows="4"
                            >
                            </textarea>
                        </tyl-form-field>
                    </td>
                </tr>
            </table>
        </div>
    </mat-dialog-content>
    
    <mat-dialog-actions>
        <div class="flex-footer-right">
            <tyl-button *ngIf = "!isFolderEdit" id="saveReportFolderButton" image="save.png" label="Save" (clickEvent)="saveReportFolderClick()"></tyl-button>
            <tyl-button *ngIf = "isFolderEdit" id="editReportFolderButton" image="save.png" label="Save" (clickEvent)="saveEditClick()"></tyl-button>
            <tyl-button id="cancelAddReportFolderButton" image="cancel.png" label="Cancel" (clickEvent)="cancelClick()"></tyl-button>
        </div>
    </mat-dialog-actions>
